export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const FETCH_ALL = 'FETCH_ALL'
export const FETCH_POST = 'FETCH_POST'
export const GET_BY_SEARCH = 'GET_BY_SEARCH'
export const LIKE = 'LIKE'
//FOR AUTH
export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'
//FOR LOADING
export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
